(() => {
  const key='kymeraLocaleTransition';
  const fields=['type','area','outdoor','facade-enabled','name','email','phone','phone-country','other-code','project-city','project-district','project-address','project-brief','other-project-type','plan'];
  const form=document.getElementById('KymeraLanguageForm');
  if (!form) return;
  const store=()=>{
    const calculator=document.querySelector('kymera-area-calculator');
    if(!calculator)return;
    const values={};
    for(const field of fields){const el=calculator.querySelector(`[data-${field}]`);if(el)values[field]=el.type==='checkbox'?el.checked:el.value;}
    try{sessionStorage.setItem(key,JSON.stringify({saved:Date.now(),path:location.pathname,values}));}catch{}
  };
  form.addEventListener('submit',store);
  form.querySelector('[name="language_code"]')?.addEventListener('change',store,{capture:true});
  const restore=()=>{
    const calculator=document.querySelector('kymera-area-calculator');
    if(!calculator)return;
    let saved;try{saved=JSON.parse(sessionStorage.getItem(key)||'null');sessionStorage.removeItem(key);}catch{return;}
    const path=value=>value.replace(/^\/(?:ar|en)(?=\/|$)/,'')||'/';
    if(!saved||Date.now()-saved.saved>600000||Date.now()<saved.saved||path(saved.path)!==path(location.pathname))return;
    for(const field of fields){
      const el=calculator.querySelector(`[data-${field}]`);const value=saved.values?.[field];
      if(!el||value===undefined)continue;
      if(el.type==='checkbox')el.checked=value===true;else el.value=String(value);
      el.dispatchEvent(new Event('input',{bubbles:true}));el.dispatchEvent(new Event('change',{bubbles:true}));
    }
    const selected=calculator.querySelector('[data-type]');
    const section=calculator.closest('.kymera-quote-flow');
    if(selected?.value&&section){
      const card=Array.from(section.querySelectorAll('.q-type-card')).find(el=>el.dataset.value===selected.value);
      card?.click();
    }
  };
  const ready=()=>customElements.whenDefined('kymera-area-calculator').then(()=>requestAnimationFrame(restore));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
